// source: protobuf/filter/request.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var protobuf_filter_condition_pb = require('../../protobuf/filter/condition_pb.js');
goog.object.extend(proto, protobuf_filter_condition_pb);
var protobuf_filter_export_pb = require('../../protobuf/filter/export_pb.js');
goog.object.extend(proto, protobuf_filter_export_pb);
goog.exportSymbol('proto.filter.OrderBy', null, global);
goog.exportSymbol('proto.filter.Request', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.filter.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.filter.Request.repeatedFields_, null);
};
goog.inherits(proto.filter.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.filter.Request.displayName = 'proto.filter.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.filter.OrderBy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.filter.OrderBy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.filter.OrderBy.displayName = 'proto.filter.OrderBy';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.filter.Request.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.filter.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.filter.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.filter.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filter.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
    pageNr: jspb.Message.getFieldWithDefault(msg, 1, 0),
    nrOfItems: jspb.Message.getFieldWithDefault(msg, 2, 0),
    search: jspb.Message.getFieldWithDefault(msg, 3, ""),
    orderByList: jspb.Message.toObjectList(msg.getOrderByList(),
    proto.filter.OrderBy.toObject, includeInstance),
    rootConditions: (f = msg.getRootConditions()) && protobuf_filter_condition_pb.GroupCondition.toObject(includeInstance, f),
    pb_export: (f = msg.getExport()) && protobuf_filter_export_pb.ExportRequest.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.filter.Request}
 */
proto.filter.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.filter.Request;
  return proto.filter.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.filter.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.filter.Request}
 */
proto.filter.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPageNr(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNrOfItems(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSearch(value);
      break;
    case 4:
      var value = new proto.filter.OrderBy;
      reader.readMessage(value,proto.filter.OrderBy.deserializeBinaryFromReader);
      msg.addOrderBy(value);
      break;
    case 5:
      var value = new protobuf_filter_condition_pb.GroupCondition;
      reader.readMessage(value,protobuf_filter_condition_pb.GroupCondition.deserializeBinaryFromReader);
      msg.setRootConditions(value);
      break;
    case 6:
      var value = new protobuf_filter_export_pb.ExportRequest;
      reader.readMessage(value,protobuf_filter_export_pb.ExportRequest.deserializeBinaryFromReader);
      msg.setExport(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.filter.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.filter.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.filter.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filter.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPageNr();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getNrOfItems();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getSearch();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOrderByList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.filter.OrderBy.serializeBinaryToWriter
    );
  }
  f = message.getRootConditions();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      protobuf_filter_condition_pb.GroupCondition.serializeBinaryToWriter
    );
  }
  f = message.getExport();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      protobuf_filter_export_pb.ExportRequest.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 page_nr = 1;
 * @return {number}
 */
proto.filter.Request.prototype.getPageNr = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.filter.Request} returns this
 */
proto.filter.Request.prototype.setPageNr = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 nr_of_items = 2;
 * @return {number}
 */
proto.filter.Request.prototype.getNrOfItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.filter.Request} returns this
 */
proto.filter.Request.prototype.setNrOfItems = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string search = 3;
 * @return {string}
 */
proto.filter.Request.prototype.getSearch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.filter.Request} returns this
 */
proto.filter.Request.prototype.setSearch = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated OrderBy order_by = 4;
 * @return {!Array<!proto.filter.OrderBy>}
 */
proto.filter.Request.prototype.getOrderByList = function() {
  return /** @type{!Array<!proto.filter.OrderBy>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.filter.OrderBy, 4));
};


/**
 * @param {!Array<!proto.filter.OrderBy>} value
 * @return {!proto.filter.Request} returns this
*/
proto.filter.Request.prototype.setOrderByList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.filter.OrderBy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.filter.OrderBy}
 */
proto.filter.Request.prototype.addOrderBy = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.filter.OrderBy, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.filter.Request} returns this
 */
proto.filter.Request.prototype.clearOrderByList = function() {
  return this.setOrderByList([]);
};


/**
 * optional GroupCondition root_conditions = 5;
 * @return {?proto.filter.GroupCondition}
 */
proto.filter.Request.prototype.getRootConditions = function() {
  return /** @type{?proto.filter.GroupCondition} */ (
    jspb.Message.getWrapperField(this, protobuf_filter_condition_pb.GroupCondition, 5));
};


/**
 * @param {?proto.filter.GroupCondition|undefined} value
 * @return {!proto.filter.Request} returns this
*/
proto.filter.Request.prototype.setRootConditions = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.filter.Request} returns this
 */
proto.filter.Request.prototype.clearRootConditions = function() {
  return this.setRootConditions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filter.Request.prototype.hasRootConditions = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional ExportRequest export = 6;
 * @return {?proto.filter.ExportRequest}
 */
proto.filter.Request.prototype.getExport = function() {
  return /** @type{?proto.filter.ExportRequest} */ (
    jspb.Message.getWrapperField(this, protobuf_filter_export_pb.ExportRequest, 6));
};


/**
 * @param {?proto.filter.ExportRequest|undefined} value
 * @return {!proto.filter.Request} returns this
*/
proto.filter.Request.prototype.setExport = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.filter.Request} returns this
 */
proto.filter.Request.prototype.clearExport = function() {
  return this.setExport(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.filter.Request.prototype.hasExport = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.filter.OrderBy.prototype.toObject = function(opt_includeInstance) {
  return proto.filter.OrderBy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.filter.OrderBy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filter.OrderBy.toObject = function(includeInstance, msg) {
  var f, obj = {
    fieldName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    direction: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.filter.OrderBy}
 */
proto.filter.OrderBy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.filter.OrderBy;
  return proto.filter.OrderBy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.filter.OrderBy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.filter.OrderBy}
 */
proto.filter.OrderBy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFieldName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDirection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.filter.OrderBy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.filter.OrderBy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.filter.OrderBy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.filter.OrderBy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFieldName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDirection();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string field_name = 1;
 * @return {string}
 */
proto.filter.OrderBy.prototype.getFieldName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.filter.OrderBy} returns this
 */
proto.filter.OrderBy.prototype.setFieldName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string direction = 2;
 * @return {string}
 */
proto.filter.OrderBy.prototype.getDirection = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.filter.OrderBy} returns this
 */
proto.filter.OrderBy.prototype.setDirection = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.filter);
